// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import {
  GET_LEAD_PRICES,
  GET_LEAD_PRICES_SUCCESS,
  GET_LEAD_PRICES_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  lead_prices: [],
  error: null,
  loading: false,
}
const LeadPrices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEAD_PRICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_LEAD_PRICES_SUCCESS:
      return {
        ...state,
        error: null,
        lead_prices: action.payload,
        loading: false,

      }

    case GET_LEAD_PRICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,

      }

    default:
      return state
  }
}

export default LeadPrices
